module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page wallet"
  }, [_c('pageTitle', {
    attrs: {
      "title": "我的代金券",
      "showRight": true
    },
    on: {
      "rightHandler": _vm.goRule
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab,
      "id": "type"
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "tab1",
      "title": "未使用"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab2",
      "title": "已使用"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab3",
      "title": "已过期"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab4",
      "title": "领取"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab5",
      "title": "兑换"
    }
  })], 1)], 1), _vm._v(" "), (_vm.activeTab === 'tab1') ? _c('div', [_c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing[0],
      "trigger": _vm.trigger
    },
    on: {
      "refresh": _vm.refresh
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "demo-refresh-container"
  }, _vm._l((_vm.vochers[0]), function(vocher) {
    return _c('div', {
      staticClass: "vocherbg"
    }, [_c('div', {
      staticClass: "vocherbg_left"
    }, [_c('div', {
      staticClass: "vochermain valid"
    }, [_vm._v("\n            ￥\n            "), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(vocher.FaceValue))])])]), _vm._v(" "), _c('div', {
      staticClass: "vocherbg_right"
    }, [_c('h4', [_vm._v(_vm._s(vocher.Name))]), _vm._v("\n          生效日期  " + _vm._s(_vm._f("dayDate")(vocher.StartDate))), _c('br'), _vm._v(" 失效日期  " + _vm._s(_vm._f("dayDate")(vocher.Enddate))), _c('br')])])
  }), 0), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "mainTitle": "您目前还没有代金券哦，邀请好友注册有机会抽取代金券、免房券！",
      "mainIcon": "noVoucher",
      "noMore": _vm.loadState[0].stop,
      "isLoading": _vm.loadState[0].loading,
      "overZero": _vm.vochers[0].length > 0
    }
  }), _vm._v(" "), (_vm.loadState[0].loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/LoadingBest.gif")
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tab2') ? _c('div', [_c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing[1],
      "trigger": _vm.trigger
    },
    on: {
      "refresh": _vm.refresh
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "demo-refresh-container"
  }, _vm._l((_vm.vochers[1]), function(vocher) {
    return _c('div', {
      staticClass: "vocherbg"
    }, [_c('div', {
      staticClass: "vocherbg_left"
    }, [_c('div', {
      staticClass: "vochermain invalid"
    }, [_vm._v("\n            ￥\n            "), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(vocher.FaceValue))])])]), _vm._v(" "), _c('div', {
      staticClass: "vocherbg_right used"
    }, [_c('h4', [_vm._v(_vm._s(vocher.Name))]), _vm._v("\n          生效日期  " + _vm._s(_vm._f("dayDate")(vocher.StartDate))), _c('br'), _vm._v(" 失效日期  " + _vm._s(_vm._f("dayDate")(vocher.Enddate))), _c('br')])])
  }), 0), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "mainTitle": "您暂无已使用代金券哦！",
      "mainIcon": "noVoucher",
      "noMore": _vm.loadState[1].stop,
      "isLoading": _vm.loadState[1].loading,
      "overZero": _vm.vochers[1].length > 0
    }
  }), _vm._v(" "), (_vm.loadState[1].loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/LoadingBest.gif")
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tab3') ? _c('div', [_c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing[2],
      "trigger": _vm.trigger
    },
    on: {
      "refresh": _vm.refresh
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "demo-refresh-container"
  }, _vm._l((_vm.vochers[2]), function(vocher) {
    return _c('div', {
      staticClass: "vocherbg"
    }, [_c('div', {
      staticClass: "vocherbg_left"
    }, [_c('div', {
      staticClass: "vochermain invalid"
    }, [_vm._v("\n            ￥\n            "), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(vocher.FaceValue))])])]), _vm._v(" "), _c('div', {
      staticClass: "vocherbg_right outdate"
    }, [_c('h4', [_vm._v(_vm._s(vocher.Name))]), _vm._v("\n          生效日期  " + _vm._s(_vm._f("dayDate")(vocher.StartDate))), _c('br'), _vm._v(" 失效日期  " + _vm._s(_vm._f("dayDate")(vocher.Enddate))), _c('br')])])
  }), 0), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "mainTitle": "您暂无已过期代金券哦！",
      "mainIcon": "noVoucher",
      "noMore": _vm.loadState[2].stop,
      "isLoading": _vm.loadState[2].loading,
      "overZero": _vm.vochers[2].length > 0
    }
  }), _vm._v(" "), (_vm.loadState[2].loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/LoadingBest.gif")
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tab4') ? _c('div', [_c('div', {
    staticClass: "receive"
  }, [_c('h3', [_vm._v("请输入您的代金券编码：")]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('mu-raised-button', {
    style: ({
      width: '100%',
      height: '50px'
    }),
    attrs: {
      "label": "领取代金券",
      "primary": ""
    },
    on: {
      "click": _vm.post
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tab5') ? _c('div', [_c('div', {
    staticClass: "exchange"
  }, [_c('h3', [_vm._v("请选择代金券类型：")]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('div', {
    class: {
      selected: _vm.money == 10
    },
    on: {
      "click": function($event) {
        _vm.money = 10
      }
    }
  }, [_c('h3', [_vm._v("10元")])]), _vm._v(" "), _c('div', {
    class: {
      selected: _vm.money == 20
    },
    on: {
      "click": function($event) {
        _vm.money = 20
      }
    }
  }, [_c('h3', [_vm._v("20元")])]), _vm._v(" "), _c('div', {
    class: {
      selected: _vm.money == 30
    },
    on: {
      "click": function($event) {
        _vm.money = 30
      }
    }
  }, [_c('h3', [_vm._v("30元")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('h3', [_vm._v("请选择代金券兑换数量：")]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('div', {
    class: {
      selected: _vm.num == 1
    },
    on: {
      "click": function($event) {
        _vm.num = 1
      }
    }
  }, [_c('h3', [_vm._v("1张")])]), _vm._v(" "), _c('div', {
    class: {
      selected: _vm.num == 2
    },
    on: {
      "click": function($event) {
        _vm.num = 2
      }
    }
  }, [_c('h3', [_vm._v("2张")])]), _vm._v(" "), _c('div', {
    class: {
      selected: _vm.num == 3
    },
    on: {
      "click": function($event) {
        _vm.num = 3
      }
    }
  }, [_c('h3', [_vm._v("3张")])])]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("\n        [温馨提示]电子代金券限用于998.com或APP预订抵扣，可抵扣的酒店及房型预订页面代金券栏标示为准。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pay",
    staticStyle: {
      "color": "black",
      "font-size": "0.24rem"
    }
  }, [_vm._v("\n        需支付\n        "), _c('span', {
    staticClass: "money"
  }, [_vm._v(_vm._s(_vm.num * _vm.money * 10))]), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("K币")]), _vm._v(" "), _c('span', {
    staticClass: "own"
  }, [_vm._v("当前K币：" + _vm._s(_vm.wallet.KCoin))])]), _vm._v(" "), _c('mu-raised-button', {
    style: ({
      width: '100%',
      height: '50px'
    }),
    attrs: {
      "label": "兑换代金券",
      "primary": ""
    },
    on: {
      "click": _vm.open
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('mu-dialog', {
    style: ({
      color: 'black'
    }),
    attrs: {
      "open": _vm.dialog,
      "id": "check"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('p', {
    staticClass: "blackword"
  }, [_vm._v("K币兑换电子代金券一旦操作成功无法撤销，请确认是否操作")]), _vm._v(" "), _c('div', {
    staticClass: "btngroup"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "取消"
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "primary": "",
      "label": "确认兑换"
    },
    on: {
      "click": _vm.kExchange
    }
  })], 1)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "id": "alertline",
      "message": _vm.hintMsg
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "explain"
  }, [_c('span', {
    staticStyle: {
      "white-space": "pre"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "white-space": "pre"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("电子代金券规则说明")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "white-space": "pre"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.24rem",
      "width": "6.68rem"
    }
  }, [_c('br'), _vm._v(" 1.会员可通过手机邮箱激活验证、格林币兑换、参加官网及APP活动等途径获取电子代金券。\n          "), _c('br'), _vm._v(" 2.每张电子代金券根据不同获取途径有效期不同，具体有效截止日期以网上会员账户界面电子代金券查询为准。\n          "), _c('br'), _vm._v(" 3.电子代金券仅限通过998.com或APP预订抵扣，可抵扣的酒店以酒店房型预订页面代金券栏标示为准。\n          "), _c('br'), _vm._v(" 4.每间夜预订限使用1张电子代金券，每间夜可抵扣限额以预订界面标示为准，代金券面额超出可抵扣限额的部分不找零。\n          "), _c('br'), _vm._v(" 5.使用电子代金券的订单不能再享受生日礼遇及其他活动优惠。\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29de583b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wallet/voucher.vue
// module id = 1459
// module chunks = 18